import { ChevronDown } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

/** Compact row that expands to detailed content (Option C). */
export function ExpandablePanel({ title, summary, children, defaultOpen = false, testId }) {
  return (
    <Collapsible defaultOpen={defaultOpen} className="border border-border/50 rounded-lg overflow-hidden">
      <CollapsibleTrigger
        className="flex w-full items-center justify-between gap-2 px-3 py-2.5 text-left hover:bg-muted/40 transition-colors"
        data-testid={testId}
      >
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium truncate">{title}</p>
          {summary && <p className="text-xs text-muted-foreground truncate mt-0.5">{summary}</p>}
        </div>
        <ChevronDown className="w-4 h-4 shrink-0 text-muted-foreground transition-transform [[data-state=open]_&]:rotate-180" />
      </CollapsibleTrigger>
      <CollapsibleContent className="px-3 pb-3 pt-0 text-sm text-muted-foreground border-t border-border/40 bg-muted/10">
        <div className="pt-3 space-y-2">{children}</div>
      </CollapsibleContent>
    </Collapsible>
  );
}
